/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { EuiButtonIcon, EuiFlexGroup, EuiFlexItem } from "@inscopix/ideas-eui";
import { GridApi, IRowNode } from "ag-grid-community";
import { DataTableColumnDefinition } from "../store/DataTableProvider.types";
import { CellStatuses } from "@inscopix/ideas-hyperformula";
import { CellValueRendererBase } from "../cell-value-renderers/CellValueRendererBase";
import { useState } from "react";
import { DataTableRowData } from "../layout/DataTable";
import { CellEditorCellStatus } from "../cell-editors/CellEditorCellStatus";

const styles = {
  root: css`
    width: 100%;
  `,
  value: css`
    min-width: 0;
    overflow: hidden;
  `,
};

interface CellRendererCellStatusProps {
  api: GridApi;
  value: CellStatuses;
  isCustomFormula: boolean;
  rowId: string;
  rowNode: IRowNode<DataTableRowData>;
  columnId: string;
  columnName: string;
  columnDefinition: Extract<DataTableColumnDefinition, { kind: "cell_status" }>;
  isCellEditable: boolean;
}

/** Cell renderer that renders cells in cell status columns */
export const CellRendererCellStatus = ({
  api,
  value,
  rowId,
  rowNode,
  columnId,
  columnName,
  columnDefinition,
  isCellEditable,
  isCustomFormula,
}: CellRendererCellStatusProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      {isModalOpen && (
        <CellEditorCellStatus
          isReadOnly
          gridApi={api}
          value={value}
          rowId={rowId}
          columnDefinition={columnDefinition}
          onChangeFormula={() => undefined}
          stopEditing={() => setIsModalOpen(false)}
        />
      )}
      <EuiFlexGroup
        css={styles.root}
        gutterSize="s"
        alignItems="flexEnd"
        justifyContent="spaceBetween"
      >
        <EuiFlexItem css={styles.value} grow={false}>
          <CellValueRendererBase
            value={value}
            isDefaultValue={!isCustomFormula}
          />
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiButtonIcon
            aria-label="Inspect cell statuses"
            iconType="inspect"
            onClick={() => {
              if (isCellEditable && rowNode.rowIndex !== null) {
                api.startEditingCell({
                  rowIndex: rowNode.rowIndex,
                  colKey: columnId,
                });
              } else {
                setIsModalOpen(true);
              }
            }}
          />
        </EuiFlexItem>
      </EuiFlexGroup>
    </>
  );
};
